import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import { ZoneCard } from "@/components/molecules/zone-card";

/**
 * ZoneCard rendue draggable (réordonnancement par Renaud). Le drag passe
 * UNIQUEMENT par la poignée (grip) : le reste de la carte garde son clic de
 * navigation intact. Le wrapper `<div ref>` est le nœud mesuré/déplacé par
 * dnd-kit — on ne touche donc pas au ref du composant Card.
 */
export function SortableZoneCard({
  id,
  name,
  planType,
  planBlob,
  mesureCount,
  onEdit,
  onDelete,
  onClick,
}: {
  id: string;
  name: string;
  planType: string;
  planBlob?: ArrayBuffer | Blob;
  mesureCount?: number;
  onEdit: () => void;
  onDelete: () => void;
  onClick?: () => void;
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    // Carte saisie : au-dessus des autres + légèrement estompée pour le feedback.
    zIndex: isDragging ? 10 : undefined,
    opacity: isDragging ? 0.6 : undefined,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <ZoneCard
        name={name}
        planType={planType}
        planBlob={planBlob}
        mesureCount={mesureCount}
        onEdit={onEdit}
        onDelete={onDelete}
        onClick={onClick}
        dragHandle={
          <button
            type="button"
            aria-label="Réordonner la zone"
            // touch-none : empêche le scroll de la page de capturer le geste de drag.
            className="tap-target -ml-1 flex cursor-grab touch-none items-center text-muted-foreground active:cursor-grabbing"
            // Un tap sur la poignée ne doit pas déclencher la navigation de la carte.
            onClick={(e) => e.stopPropagation()}
            {...attributes}
            {...listeners}
          >
            <GripVertical className="size-5" />
          </button>
        }
      />
    </div>
  );
}
